module.exports = __webpack_public_path__ + "static/media/testimonial-frame.8152d34a.jpg";